/* eslint-disable react/jsx-no-undef */
import React, { useEffect, useState, useRef } from 'react'; import Box from '@mui/material/Box';
import "../css/reset.css";
import "../css/layout.css";
import "../css/common.css";
import "../css/style.css";
import "../css/dashboard.css";
import styles from '../css/itgCtrl.module.css';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { FutureFucModule } from "../tmp/FutureFuc";
import { SwItsAvgSpeedTotalProvider, SwItsAvgSpeedTotalInfo } from 'pages/components/dashboard/SwItsGetAvgSpeed';
import { SwItsTrafficTotalProvider, SwItsTrafficTotalInfo, SwItsInOutTotalInfo } from 'pages/components/dashboard/SwitsTrafficTotalData';
import { SwItsRoadTrafficTotalProvider, SwItsRoadTrafficRight, SwItsRoadTrafficGrid } from 'pages/components/dashboard/SwItsGetTrafficRoadSpeed';
import { SwItsGetSmtTrfTotalProvider, SwItsGetSmtTrfTotalInfo } from 'pages/components/dashboard/SwItsGetSmtTrf';
import { SwItsTrafficInOutSumInfo, SwItsTrafficInOutProvider } from 'pages/components/dashboard/SwItsTrafficInOutView';
import { SwItsBisCntTotalProvider, SwItsBisCntInfo, SwItsRunBisCntDetailInfo, SwItsBisCntInfoModule } from 'pages/components/dashboard/SwItsGetBisCnt';
import { useDashboard } from 'pages/components/DashboardContext';
import useNavigation from 'pages/components/UseNavigation';
import { SwItsIndicatortsDataProvider, SwItsIndicatortsDataInfo } from 'pages/components/dashboard/SwItsGetThreeIndicatorsData';
import { SwItsGetDangerVehicleProvider, SwItsDangerVehicleTotalInfo } from 'pages/components/dashboard/SwItsGetDangerVehicle';
import { SwItsTrafficLosProvider, SwItsTrafficLosModuleIntgrControl } from 'pages/components/dashboard/SwItsGetCrsrdLos';
import { SwItsEmergVehTotalProvider, SwItsEmergVehTotalInfo, SwItsEmergVehTotalShorteningTime, SwItsEmergVehModuleTotalShorteningTime } from 'pages/components/dashboard/SwItsGetEmergVeh';
import { SwItsSnstvSignalProvider, SwItsSnstvSignalTotalInfo, SwItsIncreaseGreenSignalTotalInfo } from 'pages/components/dashboard/SwItsGetSnstvSignal';
import { SwItsGetEvntDetailProvider, SwItsGetEvntDetailInfo, SwItsGetEvntDetailChart, SwItsGetEvntDetailTotalCntInfo, SwItsGetEvntDetailChartModule, SwItsGetEvntDetailModule } from 'pages/components/dashboard/SwItsGetEvntDetail';
import { SwItsGetRoadStatTotalProvider, SwItsGetRoadStatInfo, SwItsGetRoadStatLine } from 'pages/components/dashboard/SwItsGetRoadStat';
import { SwItsFutureRouteGridInfo, SwItsGetOperationRouteProvider, SwItsDangerRouteCctvInfo } from 'pages/components/dashboard/SwItsGetOperationRoute';

import { useTranslation } from 'react-i18next';

const onlyDetectCodes = [4358, 4450, 4418, 4417, 4387, 4595]; // 검지 서칭용 이벤트

export default function IntegratedControlViewM() {
    const navigate = useNavigate();

    const { t, i18n } = useTranslation();

    const toggleLanguage = () => {
        const newLang = i18n.language === 'ko' ? 'en' : 'ko';
        i18n.changeLanguage(newLang);
    };

    useEffect(() => {
        const handleStorageChange = (e) => {
            if (e.key === 'i18nextLng' && e.newValue && e.newValue !== i18n.language) {
                i18n.changeLanguage(e.newValue);
            }
        };

        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, [i18n]);

    const { mapMessages, clearLastMapMessage } = useDashboard();

    useNavigation(mapMessages);

    useEffect(() => {
        if (mapMessages.length > 0) {
            clearLastMapMessage();
        }
    }, [mapMessages]);

    return (
        <Box sx={{ height: '100%', width: '100%' }}>
            <div className={`${styles.itgM} container`}>
                <div className="contWrap L_lmr">
                    <div className="inner L_3m">
                        <div className="titWrap flx a_center j_spc_btw">
                            <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-07)' }}>{t('TrafficFlow')}</h2>
                            <button type="button" className="morebtn" onClick={() => navigate('/module/roadTrafficView')} >
                                <img src="/images/dashboard/plus.svg" alt="자세히보기" />
                            </button>
                        </div>
                        <div className={`${styles.boxCont_itg}`}>
                            <SwItsRoadTrafficTotalProvider>
                                <div className='L_lr'>
                                    <div className='L_l flx flx_col'>
                                        <div className={`${styles.subTitle}`}>통행속도</div>
                                        <div className={`${styles.spdConts_itg} spdConts`}>
                                            <div className='top flx a_center j_spc_btw'>
                                                <SwItsAvgSpeedTotalProvider>
                                                    <div className='left innerBg flx flx_col a_center j_center'>
                                                        <SwItsAvgSpeedTotalInfo showRangeValue={true} />
                                                    </div>
                                                </SwItsAvgSpeedTotalProvider>
                                                <SwItsRoadTrafficRight />
                                            </div>
                                            <SwItsRoadTrafficGrid />
                                        </div>
                                    </div>
                                    <div className='L_s flx flx_col'>
                                        <div className={`${styles.subTitle}`}>교통량</div>
                                        <div className={`${styles.trfConts_itg} trfConts`}>
                                            <SwItsTrafficTotalProvider>
                                                <div className='top flx a_center j_spc_btw'>
                                                    <div className={`${styles.trfContsBox} left innerBg flx flx_col a_center j_center`}>
                                                        <SwItsTrafficTotalInfo showMonthValue={true} />
                                                    </div>
                                                </div>
                                            </SwItsTrafficTotalProvider>
                                            <div className='grid flx j_spc_btw'>
                                                <SwItsGetSmtTrfTotalProvider>
                                                    <div className={`${styles.trfGrid_itg} trfGrid cst_scroll`}>
                                                        <SwItsGetSmtTrfTotalInfo />
                                                    </div>
                                                </SwItsGetSmtTrfTotalProvider>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwItsRoadTrafficTotalProvider>
                        </div>
                    </div>
                    <div className="L_3m L_tb">
                        <div className="inner L_d_i flx flx_col">
                            <div className="titWrap flx a_center j_spc_btw">
                               <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-06)' }} >{t('SignalOperation')}</h2>
                                <button type="button" className="morebtn" onClick={() => navigate('/module/signalOperationViewTest')} >
                                    <img src="/images/dashboard/plus.svg" alt="자세히보기" />
                                </button>
                            </div>
                            <div className={`${styles.boxCont_itg} L_lr`}>
                                <SwItsTrafficLosProvider>
                                    <SwItsTrafficLosModuleIntgrControl />
                                </SwItsTrafficLosProvider>
                                <div className='L_l L_tb'>
                                    <div className='L_d_i_10 flx flx_col'>
                                        <div className={`${styles.subTitle}`}>긴급차량 운행 </div>
                                        <div className={`${styles.emergVehConts_itg} L_lr`}>
                                            <SwItsEmergVehTotalProvider>
                                                <div className='L_2m_10 innerBg flx flx_col j_center'>
                                                    <SwItsEmergVehTotalInfo />
                                                </div>
                                                <SwItsEmergVehModuleTotalShorteningTime valueClass='L_lr L_2m_10' detailClass='L_2m_10' />
                                            </SwItsEmergVehTotalProvider>
                                        </div>
                                    </div>
                                    <div className='L_d_i_10 flx flx_col'>
                                        <div className={`${styles.subTitle}`}>감응현황
                                        </div>
                                        <div className={`${styles.snstvSgnlConts_itg} L_lr`}>
                                            <SwItsSnstvSignalProvider>
                                                <div className='L_2m_10 innerBg flx flx_col j_center'>
                                                    <SwItsSnstvSignalTotalInfo />
                                                </div>
                                                <div className='L_2m_10 innerBg flx flx_col j_center'>
                                                    <SwItsIncreaseGreenSignalTotalInfo />
                                                </div>
                                            </SwItsSnstvSignalProvider>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="inner L_d_i flx flx_col">
                            <div className="titWrap flx a_center j_spc_btw">
                                <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-05)' }}>{t('BusOperation')}</h2>
                                <button type="button" className="morebtn" onClick={() => navigate('/module/busOperationView')} >
                                    <img src="/images/dashboard/plus.svg" alt="자세히보기" />
                                </button>
                            </div>
                            <div className={`${styles.boxCont_itg} L_lr`}>
                                <SwItsBisCntTotalProvider>
                                    <div className='L_s'>
                                        <div className={`${styles.subTitle}`}>운행현황</div>
                                        <div className={`${styles.busInfoConts_itg} busInfoConts`}>
                                            <div className={`${styles.top_itg} flx flx_col`}>
                                                <div className='mainBox flx flx_col a_center j_center'>
                                                    <p>운행중</p>
                                                    <SwItsBisCntInfoModule />
                                                </div>
                                            </div>
                                            <div className={`${styles.btm_itg} flx j_spc_btw`}>
                                                <div className='mainBox flx flx_col a_center j_center'>
                                                    <p>노선</p>
                                                    <SwItsBisCntInfo title={'route'} />
                                                </div>
                                                <div className='mainBox flx flx_col a_center j_center'>
                                                    <p>정류장</p>
                                                    <SwItsBisCntInfo title={'station'} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='L_l'>
                                        <div className={`${styles.subTitle}`}>BIS 기준지표 현황</div>
                                        <SwItsIndicatortsDataProvider>
                                            <div className={`${styles.idctDataConts_itg} idctDataConts`}>
                                                <SwItsIndicatortsDataInfo />
                                            </div>
                                        </SwItsIndicatortsDataProvider>
                                    </div>
                                </SwItsBisCntTotalProvider>
                            </div>
                        </div>
                    </div>
                    <div className="L_3m L_tb">
                        <div className="inner L_d_i flx flx_col">
                            <div className="titWrap flx a_center j_spc_btw">
                              <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-04)' }}>{t('TrafficSafety')}</h2>
                                <button type="button" className="morebtn" onClick={() => navigate('/module/trafficSafetyView')} >
                                    <img src="/images/dashboard/plus.svg" alt="자세히보기" />
                                </button>
                            </div>
                            <div className={`${styles.boxCont_itg} L_lr`}>
                                <div className='L_tb L_4'>
                                    <div className='L_d_i flx flx_col'>
                                        <div className={`${styles.subTitle}`}>위험물질 운송차량</div>
                                        <div className={`${styles.dangVehConts_itg} dangVehConts boxCont flx flx_col`}>
                                            <SwItsGetDangerVehicleProvider>
                                                <SwItsDangerVehicleTotalInfo />
                                            </SwItsGetDangerVehicleProvider>
                                        </div>
                                    </div>
                                    <div className='L_d_i flx flx_col'>
                                        <div className={`${styles.subTitle}`}>노면상태</div>
                                        <div className={`${styles.rdStusConts_itg} rdStusConts`}>
                                            <SwItsGetRoadStatTotalProvider>
                                                <SwItsGetRoadStatInfo hideSoundBtn />
                                            </SwItsGetRoadStatTotalProvider>
                                        </div>
                                    </div>
                                </div>
                                <SwItsGetEvntDetailProvider>
                                    <div className='L_6'>
                                        <div className={`${styles.subTitle}`}>교차로 돌발 및 위험행동</div>
                                        <div className={`${styles.unxpConts_itg} unxpConts flx`}>
                                            <div className="unxpchart">
                                                <SwItsGetEvntDetailChartModule className={`${styles.mdulItgChart}`} />
                                            </div>
                                            <div className="unxpGrid flx flx_col j_spc_btw">
                                                <SwItsGetEvntDetailModule
                                                    isInclude={true}          // 검지 코드만 
                                                    targetCodes={onlyDetectCodes}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </SwItsGetEvntDetailProvider>
                            </div>
                        </div>
                        <div className="inner L_d_i flx flx_col">
                            <div className="titWrap flx a_center j_spc_btw">
                                  <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-03)' }}>{t('AVoperation')}</h2>
                                <button type="button" className="morebtn" onClick={() => navigate('/module/futureTransportationView')} >
                                    <img src="/images/dashboard/plus.svg" alt="자세히보기" />
                                </button>
                            </div>
                            <div className={`${styles.boxCont_itg} ${styles.boxContFt_itg} flx a_center`}>
                                <div className={`${styles.ftvCont_left_itg} ftvCont_left flx flx_col`}>
                                    <SwItsGetOperationRouteProvider>
                                        <SwItsFutureRouteGridInfo />
                                    </SwItsGetOperationRouteProvider>
                                </div>
                                <div className={`${styles.ftvMap_itg} ftvMap`}>
                                    <div
                                        className="mapBox"
                                        style={{ width: "100%", height: "100%" }}>
                                        <FutureFucModule />
                                    </div>
                                    {/* <img src="/images/module/Ft_M_img.svg" alt="미래교통지도영역"></img> */}
                                </div>
                                {/* <div className="ftvCont_right flx flx_col">
                                    <div className="cctvWrap flx flx_col">
                                        <SwItsDangerRouteCctvInfo cameraCount={3}/>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Box>
    )
}